var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAudienceIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 29v1H2V29a3.992 3.992 0 012.35-3.635 2.5 2.5 0 113.3 0A3.992 3.992 0 0110 29zM20 29v1H12V29a3.992 3.992 0 012.35-3.635 2.5 2.5 0 113.3 0A3.992 3.992 0 0120 29zM30 29v1H22V29a3.992 3.992 0 012.35-3.635 2.5 2.5 0 113.3 0A3.992 3.992 0 0130 29z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4981.5-739a.5.5,0,0,1-.5-.5v-16a.5.5,0,0,1,.5-.5h27a.5.5,0,0,1,.5.5v16a.5.5,0,0,1-.5.5Z",
    transform: "translate(-4981 756)",
    fill: "#51525f"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAudienceIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AudienceIcon.2d5190d7a8ad70774376276f3186b782.svg";